// extracted by mini-css-extract-plugin
export var table = "_ux-0";